import React from "react";
import css from "./section.module.css";
import { NavLink } from "react-router-dom";
const Card2 = ({ feature }) => {
  const { image, title, desc, bg } = feature;
  return (
    <div style={{ backgroundColor: bg }} className={css.card2}>
      <div className={css.text_div}>
        <h4>{title}</h4>
        <p>{desc}</p>
        <div className={css.card2_btn}>
          <NavLink>
            <button>Start For Free</button>
          </NavLink>
        </div>
      </div>
      <div className={css.img_div}>
        <img src={image} alt={title} />
      </div>
    </div>
  );
};

export default Card2;
